/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PermissionVm,
    PermissionVmFromJSON,
    PermissionVmFromJSONTyped,
    PermissionVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface PermissionVmPaginatedSearchResponse
 */
export interface PermissionVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<PermissionVm>}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    items?: Array<PermissionVm> | null;
    /**
     * 
     * @type {number}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionVmPaginatedSearchResponse
     */
    size?: number;
}

export function PermissionVmPaginatedSearchResponseFromJSON(json: any): PermissionVmPaginatedSearchResponse {
    return PermissionVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function PermissionVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(PermissionVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function PermissionVmPaginatedSearchResponseToJSON(value?: PermissionVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(PermissionVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


